var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAlgorim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 230.87 205.56",
    width: 71,
    height: 63,
    className: "logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 41.6,
    x2: 230.87,
    y2: 41.6,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 210)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#358446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#59aa47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 106.72,
    x2: 120.54,
    y2: 106.72,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 210)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6ce39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#68ad45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 97.34,
    y1: 202.51,
    x2: 196.6,
    y2: 9.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 210)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbdb2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8dc63f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,185.07c5,6.78,9.77,13.52,14.4,20.43A238.66,238.66,0,0,1,225,165.59a123.7,123.7,0,0,0,5.86-24.43A263.49,263.49,0,0,0,0,185.07Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.54,1C116.46.65,112.2,3,108,3S99.78.69,95.61,1A239.57,239.57,0,0,1,68.77,104,239.58,239.58,0,0,1,0,185.14a123.69,123.69,0,0,0,14.4,20.42,264.44,264.44,0,0,0,76.51-90.09A264.56,264.56,0,0,0,120.54,1Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68,205.24A123.83,123.83,0,0,0,216,184.68a239.46,239.46,0,0,1-68.7-81.15A239.58,239.58,0,0,1,120.49.65,123.26,123.26,0,0,0,108,0,121.47,121.47,0,0,0,95.47.65a264.58,264.58,0,0,0,29.65,114.47A264.46,264.46,0,0,0,201.68,205.24Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlgorim);
export default __webpack_public_path__ + "static/media/logo-algorim.7cf2a919f278184b58c155a5f76a907d.svg";
export { ForwardRef as ReactComponent };